// Reducer para groupingUser
import {
  FETCH_GROUPING_USER_REQUEST,
  FETCH_GROUPING_USER_SUCCESS,
  FETCH_GROUPING_USER_FAILURE,
} from './types';

const initialState = {
  loading: false,
  data: null,
  error: null,
};

export default function groupingUserReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_GROUPING_USER_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_GROUPING_USER_SUCCESS:
      return { ...state, loading: false, data: action.payload };
    case FETCH_GROUPING_USER_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
}
